<template>
  <div class="update-back">
    <div class="update-left">
      <div class="update-first">更新日志</div>
      <div class="platform-list">
        <div
          class="platform"
          :style="{
            backgroundColor: select_platform === 'wxmp' ? 'rgb(211, 232, 255)' : '#fff',
          }"
          @click="select_platform = 'wxmp'"
        >
          <div class="text">微信小程序</div>
          <!-- <div v-show="select_platform=='wxmp'" class="plateform_con">wxmp</div> -->
        </div>
        <div
          class="platform"
          :style="{
            backgroundColor: select_platform === 'pc' ? 'rgb(211, 232, 255)' : '#fff',
          }"
          @click="select_platform = 'pc'"
        >
          <div class="text">Windows</div>
          <!-- <div v-show="select_platform=='pc'" class="plateform_con">windows</div> -->
        </div>
        <div
          class="platform"
          :style="{
            backgroundColor: select_platform === 'ydkt-pc' ? 'rgb(211, 232, 255)' : '#fff',
          }"
          @click="select_platform = 'ydkt-pc'"
        >
          <div class="text">翼渡课堂</div>
          <!-- <div v-show="select_platform=='pc'" class="plateform_con">windows</div> -->
        </div>
      </div>
    </div>
    <div class="update-right" v-if="select_platform === 'wxmp'">
      <div class="update-right-con">
        <h1>蜥翼虚拟仿真实验室&nbsp;{{ wx_version }}&nbsp;for&nbsp;微信小程序全新发布</h1>
        <br/>
        <br/>
        <div style="font-size: 0.8vw">发布日期：{{ wxmp_update_time }}</div>
        <br/>
        <div style="font-size: 0.8vw; display: flex">
          <span style="margin-right: 0.3vw"
          >发布版本：蜥翼虚拟仿真实验室&nbsp;{{
              wx_version
            }}&nbsp;for&nbsp;微信小程序</span
          >
          <el-popover placement="top-start" trigger="hover">
            <div class="qrcode"></div>
            <div slot="reference" class="" style="">
              <div style="color: #2b8dff; cursor: pointer">下载最新版本</div>
            </div>
          </el-popover>
        </div>
        <br/>
        <br/>
        <div style="font-size: 0.8vw">该版本主要更新如下：</div>
        <br/>
        <div
          style="
            white-space: pre;
            font-size: 0.8vw;
            font-weight: bold;
            line-height: 1.6vw;
          "
        >
          <div v-for="(item, index) in info_wxmp">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="update-right" v-else-if="select_platform === 'pc'">
      <div class="update-right-con">
        <h1>
          蜥翼虚拟仿真实验室&nbsp;<span>{{ pc_version }}&nbsp;</span>for Windows全新发布
        </h1>
        <br/>
        <br/>
        <div style="font-size: 0.8vw">发布日期：{{ pc_update_time }}</div>
        <br/>
        <div style="font-size: 0.8vw">
          发布版本：蜥翼虚拟仿真实验室&nbsp;<span>{{ pc_version }}&nbsp;</span>for Windows
          <span style="color: #2b8dff; cursor: pointer" @click="downloadApp('pc')"
          >下载最新版本</span
          >
        </div>
        <br/>
        <br/>
        <div style="font-size: 0.8vw">该版本主要更新如下：</div>
        <br/>
        <div
          style="
            white-space: pre;
            font-size: 0.8vw;
            font-weight: bold;
            line-height: 1.6vw;
          "
        >
          <div v-for="(item, index) in info">{{ item }}</div>
        </div>
        <br/>
        <div>
          <span
            style="font-size: 0.8vw; color: #2b8dff; cursor: pointer"
            @click="downloadApp('pc')"
          >下载32位版本</span
          >
        </div>
      </div>
    </div>
    <div class="update-right" v-else-if="select_platform === 'ydkt-pc'">
      <div class="update-right-con">
        <h1>
          翼渡课堂&nbsp;<span>{{ ydkt_pc_version }}&nbsp;</span>for Windows全新发布
        </h1>
        <br/>
        <br/>
        <div style="font-size: 0.8vw">发布日期：{{ ydkt_pc_update_time }}</div>
        <br/>
        <div style="font-size: 0.8vw">
          发布版本：翼渡课堂&nbsp;<span>{{ ydkt_pc_version }}&nbsp;</span>for Windows
          <span style="color: #2b8dff; cursor: pointer" @click="downloadApp('ydkt-pc')"
          >下载最新版本</span
          >
        </div>
        <br/>
        <br/>
        <div style="font-size: 0.8vw">该版本主要更新如下：</div>
        <br/>
        <div
          style="
            white-space: pre;
            font-size: 0.8vw;
            font-weight: bold;
            line-height: 1.6vw;
          "
        >
          <div v-for="(item, index) in ydkt_info">{{ item }}</div>
        </div>
        <br/>
        <div>
          <span
            style="font-size: 0.8vw; color: #2b8dff; cursor: pointer"
            @click="downloadApp('ydkt-pc-32')"
          >下载32位版本</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getPCDownLoadInfo, getWXDownLoadInfo, getYDKT32DownloadURL, getYDKTDownloadURL} from "../api/app.js";

export default {
  name: "version",
  layout: "app",
  data() {
    return {
      select_platform: "wxmp",
      pc_version: "",
      wx_version: "",
      downloadUrl_pc: "",
      downloadUrl_pc_ydkt:'',
      downloadUrl_pc_ydkt_32:'',
      pc_update_time: "",
      info_wxmp: "",
      info: "",
      ydkt_info:"",
      wxmp_update_time: "",
      ydkt_pc_update_time:'',
      ydkt_pc_version:''
    };
  },
  created() {
    if (this.$route.query.type) {
      //获取左侧tabs属性
      this.select_platform = this.$route.query.type;
    }
  },
  mounted() {
    getPCDownLoadInfo(location.protocol).then((res) => {
      //获取版本号和下载地址
      if (res.code == 200) {
        this.info = res.data.remark.split("\\n ");
        this.pc_version = res.data.version.split(" ")[0];
        this.downloadUrl_pc = res.data.url;
        let time = res.data.version.split("build-")[1];
        console.log(time);
        if (time[4] == 0 || time[6] == 0) {
          if (time[4] == 0 && time[6] == 0) {
            this.pc_update_time =
              time.slice(0, 4) + "年" + time.slice(5, 6) + "月" + time.slice(7, 8) + "日";
          } else if (time[4] == 0) {
            this.pc_update_time =
              time.slice(0, 4) + "年" + time.slice(5, 6) + "月" + time.slice(6, 8) + "日";
          } else if (time[6] == 0) {
            this.pc_update_time =
              time.slice(0, 4) + "年" + time.slice(4, 6) + "月" + time.slice(7, 8) + "日";
          }
        } else {
          this.pc_update_time =
            time.slice(0, 4) + "年" + time.slice(4, 6) + "月" + time.slice(6, 8) + "日";
        }

        console.log(this.pc_update_time);
      }
    });
    getWXDownLoadInfo(location.protocol).then((res) => {
      //获取版本号和下载地址
      if (res.code == 200) {
        this.info_wxmp = res.data.remark.split("\\n ");
        this.wx_version = res.data.version.split(" ")[0];
        let time = res.data.version.split("build-")[1];
        if (time[4] == 0 || time[6] == 0) {
          if (time[4] == 0 && time[6] == 0) {
            this.wxmp_update_time =
              time.slice(0, 4) + "年" + time.slice(5, 6) + "月" + time.slice(7, 8) + "日";
          } else if (time[4] == 0) {
            this.wxmp_update_time =
              time.slice(0, 4) + "年" + time.slice(5, 6) + "月" + time.slice(6, 8) + "日";
          } else if (time[6] == 0) {
            this.wxmp_update_time =
              time.slice(0, 4) + "年" + time.slice(4, 6) + "月" + time.slice(7, 8) + "日";
          }
        } else {
          this.wxmp_update_time =
            time.slice(0, 4) + "年" + time.slice(4, 6) + "月" + time.slice(6, 8) + "日";
        }
      }
    });
    getYDKTDownloadURL(location.protocol).then((res) => {
      //获取版本号和下载地址
      if (res.code == 200) {
        this.ydkt_info = res.data.changeLog.split("#")
        this.ydkt_pc_version = res.data.version.split(" ")[0];
        let time = res.data.version.split("build-")[1];
        this.downloadUrl_pc_ydkt = res.data.url;
        if (time[4] == 0 || time[6] == 0) {
          if (time[4] == 0 && time[6] == 0) {
            this.ydkt_pc_update_time =
              time.slice(0, 4) + "年" + time.slice(5, 6) + "月" + time.slice(7, 8) + "日";
          } else if (time[4] == 0) {
            this.ydkt_pc_update_time =
              time.slice(0, 4) + "年" + time.slice(5, 6) + "月" + time.slice(6, 8) + "日";
          } else if (time[6] == 0) {
            this.ydkt_pc_update_time =
              time.slice(0, 4) + "年" + time.slice(4, 6) + "月" + time.slice(7, 8) + "日";
          }
        } else {
          this.ydkt_pc_update_time =
            time.slice(0, 4) + "年" + time.slice(4, 6) + "月" + time.slice(6, 8) + "日";
        }
      }
    });
    getYDKT32DownloadURL(location.protocol).then((res) => {
      //获取版本号和下载地址
      if (res.code == 200) {
        this.downloadUrl_pc_ydkt_32 = res.data.url;

      }
    });
  },
  methods: {
    downloadApp(type) {
      //下载按钮
      if (type == "pc") {
        const a = document.createElement("a");
        a.href = this.downloadUrl_pc;
        a.click();
      }
      if (type == "ydkt-pc") {
        const a = document.createElement("a");
        a.href = this.downloadUrl_pc_ydkt;
        a.click();
      }
      if (type == "ydkt-pc-32") {
        const a = document.createElement("a");
        a.href = this.downloadUrl_pc_ydkt_32;
        a.click();
      }
    },
  },
};
</script>

<style scoped>
.qrcode {
  width: 10vw;
  height: 10vw;
  margin: auto;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url("http://data.xiyilab.com/web/main/static/qrcode.png");
}

.download-btn:active {
  transform: translate(2px, 2px);
}

.download-btn-img {
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/二维码.png");
  width: 1vw;
  height: 1vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.download-icon {
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/下载.png");
}

.update-right-con {
  width: 50%;
  height: 100%;
  margin: 0 auto;
}

.update-back {
  background-color: rgb(249, 250, 255);
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.update-right {
  width: 85vw;
  height: 100vh;
  padding: 5vw 7vw;
}

.update-left {
  width: 15vw;
  height: 100vh;
  background-color: rgb(255, 255, 255);

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.update-first {
  font-size: 1.2vw;
  font-weight: bold;
  text-align: left;
  color: rgb(62, 58, 57);
  line-height: 3vw;
  padding-left: 2vw;
}

.platform-list {
  font-size: 1vw;
  font-weight: 400;
  cursor: pointer;
  width: 15vw;
  line-height: 3vw;
}

.text {
  margin-left: 4vw;
}

.platform {
  background-color: #d8d8d8;
  margin-top: 0.5vw;
}

.platform:hover {
  background-color: rgb(211, 232, 255);
}

.plateform_con {
  background-color: #fff;
  text-align: center;
}
</style>
